<template>
  <div class="mt-7 d-flex flex-column align-start justify-start">
    <div class="d-flex align-center justify-start mt-2 tab">
      <v-skeleton-loader
        v-if="isAdminOn"
        type="image"
        width="186px"
        height="48px"
        class="mr-2"
      />
      <v-skeleton-loader
        type="image"
        width="186px"
        height="48px"
        class="mr-2"
      />
      <v-skeleton-loader
        type="image"
        width="186px"
        height="48px"
        class="mr-2"
      />
      <v-skeleton-loader
        type="image"
        width="186px"
        height="48px"
        class="mr-2"
      />
    </div>
    <div class="d-flex align-center justify-start tab-items">
      <v-skeleton-loader
        type="image"
        width="220px"
        :height="isAdminOn ? '123px' : '92px'"
        class="mr-4 mt-4"
        :class="{ 'admin-on': isAdminOn }"
      />
      <v-skeleton-loader
        type="image"
        width="220px"
        :height="isAdminOn ? '123px' : '92px'"
        class="mr-4 mt-4"
        :class="{ 'admin-on': isAdminOn }"
      />
      <v-skeleton-loader
        type="image"
        width="220px"
        :height="isAdminOn ? '123px' : '92px'"
        class="mr-4 mt-4"
        :class="{ 'admin-on': isAdminOn }"
      />
    </div>
    <div
      v-if="!isAdminOn"
      class="d-flex align-center justify-start tab-item-no-admin"
    >
      <v-skeleton-loader
        type="image"
        width="220px"
        height="92px"
        class="mr-4 mt-4"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeTabsSkeletonLoader',
  props: {
    isAdminOn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader__image) {
  border-radius: 4px;
}
.tab {
  :deep(.v-skeleton-loader__image) {
    height: 48px;
  }
}

.tab-items {

  .admin-on :deep(.v-skeleton-loader__image) {
    height: 123px;
  }

  :deep(.v-skeleton-loader__image) {
    height: 92px;
  }
}

.tab-item-no-admin {
  :deep(.v-skeleton-loader__image) {
    height: 92px;
  }
}
</style>
